/**
 * Swiper React 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */

"use strict";

exports.__esModule = true;

var _swiper = require("./cjs/react/swiper");

exports.Swiper = _swiper.Swiper;

var _swiperSlide = require("./cjs/react/swiper-slide");

exports.SwiperSlide = _swiperSlide.SwiperSlide;
